export default __webpack_public_path__ + "static/media/ThursdayRingRing.376530bc.png";